module.exports = __webpack_public_path__ + "img/39.959a7d7c.png";